import { useTheme } from '@/contexts/ThemeContext';

export const BRAND_ASSETS = {
  logo: { light: '/brand/logo-color.png', dark: '/brand/logo-white-gold.png' },
  mark: { light: '/brand/mark-color.png', dark: '/brand/mark-white-gold.png' },
};

function useOnDark(onDark) {
  const theme = useTheme();
  return onDark ?? Boolean(theme?.isDark);
}

export function BrandMark({ className = 'w-10 h-10', onDark, alt = 'Estadía 365' }) {
  const dark = useOnDark(onDark);
  return (
    <img src={dark ? BRAND_ASSETS.mark.dark : BRAND_ASSETS.mark.light} alt={alt}
      className={`${className} object-contain select-none`} draggable={false} data-testid="brand-mark" />
  );
}

export function BrandLogo({ className = 'h-16 w-auto', onDark, alt = 'Estadía 365 - Alquileres y Ventas' }) {
  const dark = useOnDark(onDark);
  return (
    <img src={dark ? BRAND_ASSETS.logo.dark : BRAND_ASSETS.logo.light} alt={alt}
      className={`${className} object-contain select-none`} draggable={false} data-testid="brand-logo" />
  );
}
